module.exports = __webpack_public_path__ + "static/media/sriracha-teen-hero-mobile.bdc9daf9.jpg";